export const config = {
    headerImg: require('@/assets/images/company/header.png'),
    headerTitle: '凡百事之成也 必在敬之',
    headerDesc: '——《荀子·议兵》',
    navList: [
        { name: '公司简介', path: 'company' },
        { name: '分支机构', path: 'branch' },
        { name: '资质荣誉', path: 'qualification_honor' },
        { name: '敬在的观点与优势', path: 'viewpoints_advantages' },
        { name: '新闻动态', path: 'news_information' },
        { name: '人才招聘', path: 'job' },

    ],
    title: '',
    desc: '',
    companyDesc: '荣科科技深耕智慧城市和智慧医疗领域、人工智能应用领域，打造了涵盖智慧民生、智慧能源的荣科智维云品牌，旗下拥有上海米健、神州视翰、上海今创、上海敬在四个医疗信息化品牌，覆盖门诊、急诊、手术室、病房、病案、远程医疗、医保控费、后勤等细分领域。目前已服务我国超八成的“百强医院”、超4000家医疗机构。',
    workSrc: require('@/assets/images/company/img_intro_banner.png'),
    descList: [
        { title: '智能产品', desc: '基于全新一代数字化、智能化技术、深入医院智慧管理业务场景', descMore: '上海敬在信息技术有限公司(以下简称：敬在信息)是“国家专精特新企业”、“国家高新技术企业”、“国家双软认证企业”、“国内最早的HRP专业团队”，秉承“智能产品、智慧方案、敬在服务”理念，基于全新一代数字化、智能化技术、深入医院智慧管理业务场景，融合云计算、互联网、物联网、大数据技术，驱动医院智慧运营管理创新与实践。' },
        { title: '智慧方案', desc: '融合云计算、互联网、物联网、大数据技术，驱动医院智慧运营管理创新与实践', descMore: '以敬在HRP系列产品、敬在AI智慧管理产品、敬在成本管理与分析平台、敬在全面绩效管理平台、敬在蜂采供应链SPD协同平台、敬在智慧设备SAAS服务平台、敬在移动应用聚合平台、敬在运营数据中心ODR等产品为依托，敬在信息融合AI人工智能、云计算、互联网、物联网、大数据技术，驱动医院智慧运营管理创新与实践，赋能智慧医院体系建设。' },
        { title: '敬在服务', desc: '众多大型三甲、医疗集团、医共体成功案例，赋能医疗机构降本增效与数字化、智能化转型', descMore: '面向大中型医疗机构、医疗集团、医共体、卫健、医保主管部门及基层医疗机构，针对运营管理、流程管控、数据治理与分析等业务，提供全新一代智慧运营管理系统、区域卫生经济运行与监管平台的产品和解决方案，赋能医疗机构降本增效与数字化、智能化转型。' },
    ],
    companyYear: {
        year: '19', yearName: '年', yearString: '+', descTop: '深耕医疗，专注医院智慧运营管理', descBottom: '超过19年医院运营管理信息化服务经验'
    },
    companyYear2: {
        year: '5', yearName: '级', descTop: '超越医院智慧管理5级别标准', descBottom: '产品完全满足《医院智慧管理分级评估标准体系》政策要求'
    },
    footer: {
        title1: '凡百事之成也，必',
        title2: '在敬',
        title3: '之；其败也，必在慢之。',
        info: '——《荀子·议兵》'
    }
}
